var map = {
	"./de/general9/slide1.svg": 14774,
	"./en/general9/slide1.svg": 243714,
	"./es/general9/slide1.svg": 893023,
	"./fr/general9/slide1.svg": 807431,
	"./nl/general9/slide1.svg": 554353,
	"./pt/general9/slide1.svg": 866099
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 11880;